let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8smjP")).then(() => parcelRequire('jTJ2Q'));